import { render, staticRenderFns } from "./chargeNeedsKnow.vue?vue&type=template&id=af0cd6d8&scoped=true&"
import script from "./chargeNeedsKnow.vue?vue&type=script&lang=js&"
export * from "./chargeNeedsKnow.vue?vue&type=script&lang=js&"
import style0 from "./chargeNeedsKnow.vue?vue&type=style&index=0&id=af0cd6d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0cd6d8",
  null
  
)

export default component.exports